var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeAndSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 81,
    viewBox: "0 0 120 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.2651 17.4883H71.8828V26.8706H81.2651V17.4883Z",
    fill: "#F58120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.144 17.4883H84.7617V26.8706H94.144V17.4883Z",
    fill: "#F58120"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.02 17.4883H97.6382V26.8706H107.02V17.4883Z",
    fill: "#F58120"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2651 30.5469H71.8828V39.9292H81.2651V30.5469Z",
    fill: "#F58120"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.144 30.5469H84.7617V39.9292H94.144V30.5469Z",
    fill: "#F58120"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.02 30.5469H97.6382V39.9292H107.02V30.5469Z",
    fill: "#F58120"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2651 42.5078H71.8828V51.8901H81.2651V42.5078Z",
    fill: "#F58120"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.144 42.5078H84.7617V51.8901H94.144V42.5078Z",
    fill: "#F58120"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.02 42.5078H97.6382V51.8901H107.02V42.5078Z",
    fill: "#F58120"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2651 56.1211H71.8828V65.5034H81.2651V56.1211Z",
    fill: "#F58120"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.144 56.1211H84.7617V65.5034H94.144V56.1211Z",
    fill: "#F58120"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.02 56.1211H97.6382V65.5034H107.02V56.1211Z",
    fill: "#F58120"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4619 32.408C45.4619 28.1159 41.9691 24.623 37.6769 24.623H36.9227C32.6305 24.623 29.1377 28.1146 29.1377 32.408V38.4672H45.4619V32.408Z",
    fill: "#528FF5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1201 67.5228H60.4788V14.543H14.1201V67.5228ZM22.7442 40.4377C22.7442 39.3508 23.6257 38.4693 24.7126 38.4693H26.4133V32.4101C26.4133 26.6069 31.1177 21.9025 36.921 21.9025H37.6753C43.4785 21.9025 48.1829 26.6069 48.1829 32.4101V38.4693H49.8836C50.9706 38.4693 51.8521 39.3508 51.8521 40.4377V58.0172C51.8521 59.1042 50.9706 59.9857 49.8836 59.9857H24.7126C23.6257 59.9857 22.7442 59.1042 22.7442 58.0172V40.4377Z",
    fill: "#528FF5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8811 47.3277C40.8811 45.3487 39.2772 43.7461 37.2994 43.7461C35.3204 43.7461 33.7178 45.35 33.7178 47.3277C33.7178 48.8588 34.6801 50.1618 36.0322 50.6748L33.9418 54.8556H40.6597L38.5335 50.6867C39.9015 50.1843 40.8811 48.872 40.8811 47.3277Z",
    fill: "#528FF5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.922 0.359375H9.37964C4.20864 0.359375 0 4.56669 0 9.73901V70.9797C0 76.1521 4.20864 80.3594 9.37964 80.3594H109.922C115.094 80.3594 119.3 76.1507 119.3 70.9797V9.73901C119.3 4.56669 115.093 0.359375 109.922 0.359375ZM115.989 70.9784C115.989 74.3241 113.267 77.0468 109.922 77.0468H9.37964C6.03393 77.0468 3.31124 74.3241 3.31124 70.9784V9.73901C3.31124 6.39331 6.03393 3.67194 9.37964 3.67194H109.922C113.267 3.67194 115.989 6.39331 115.989 9.73901V70.9784Z",
    fill: "#7BC658"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafeAndSecure);
export default __webpack_public_path__ + "static/media/safeAndSecure.72431dd95daf814003cb80cec9d84631.svg";
export { ForwardRef as ReactComponent };